import { render } from "./shopSearch.vue?vue&type=template&id=33e21baa&scoped=true"
import script from "./shopSearch.vue?vue&type=script&lang=js"
export * from "./shopSearch.vue?vue&type=script&lang=js"

import "./shopSearch.vue?vue&type=style&index=0&id=33e21baa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33e21baa"

export default script